module.exports = __webpack_public_path__ + "img/采购费.83a372db.svg";